export const HasSeenDashboard = 'hasSeenDashboard'
export const HasSeenGettingStartedTab = 'hasSeenGettingStartedTab'
